// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"BrbK0W"};